import React from 'react';
import '../../styles/GestionDeUsuarios.css'; // Usamos los estilos existentes que ya definen este layout

/**
 * Componente de layout reutilizable para las páginas de gestión de administrador.
 * Crea una vista de dos paneles: uno para la lista y otro para los detalles.
 * @param {object} props
 * @param {React.ReactNode} props.listPanel - El componente a renderizar en el panel izquierdo (la lista).
 * @param {React.ReactNode} props.detailsPanel - El componente a renderizar en el panel derecho (los detalles).
 */
const AdminManagementLayout = ({ listPanel, detailsPanel }) => {
    return (
        <div className="management-container">
            <div className="user-list-panel">{listPanel}</div>
            <div className="user-details-panel">{detailsPanel}</div>
        </div>
    );
};

export default AdminManagementLayout;